// Las tandas del lienzo SIN las creaciones borradas —
// ADR-2026-10-04-eliminar-saca-la-creacion-de-la-vista. El lienzo guarda en el chat qué
// fotos tiene cada tanda; si una se elimina, su id sigue ahí y la celda quedaba como un
// recuadro gris (la fila ya no tiene archivo). Se sacan al dibujar, sin tocar lo guardado.
// Los recuadros que todavía no tienen foto (generando) no se tocan; una tanda que se quedó
// sin ninguna celda desaparece entera. Puro.

import type { TandaDelLienzo } from './tandasDelLienzo';

export function sinBorradas(tandas: TandaDelLienzo[], estaBorrada: (imageId: string) => boolean): TandaDelLienzo[] {
  let cambio = false;
  const out: TandaDelLienzo[] = [];
  for (const t of tandas) {
    const celdas = t.celdas.filter((c) => !c.imageId || !estaBorrada(c.imageId));
    if (celdas.length === t.celdas.length) {
      out.push(t);
      continue;
    }
    cambio = true;
    if (celdas.length > 0) out.push({ ...t, celdas });
  }
  // Sin nada borrado se devuelve el MISMO array: el acomodo no se rehace.
  return cambio ? out : tandas;
}
